import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { BoxDirectoryForm } from "./BoxDirectoryForm";

export const AddBoxDirectoryModal = ({ resourcePath, boxDirectory, onAdd }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const toggleModal = () => setOpen(!open);
  const title = "Add Box Directory";

  const handleCreate = async (values) => {
    setError(null);
    try {
      const { data } = await api.post(`${resourcePath}/box_directories`, snakifyKeys({ boxDirectory: values }));

      if (data) {
        onAdd(data);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal}>{title}</Button>

      <Modal isOpen={open} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>{title}</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <BoxDirectoryForm handleAction={handleCreate} boxDirectory={boxDirectory} />
        </ModalBody>
      </Modal>
    </>
  );
};
